/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FarmacoDto } from '../../models/farmaco-dto';

export interface FarmacosControllerGetTodosFarmacosEliminadosPaciente$Params {
  programaUuid: string;
}

export function farmacosControllerGetTodosFarmacosEliminadosPaciente(http: HttpClient, rootUrl: string, params: FarmacosControllerGetTodosFarmacosEliminadosPaciente$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FarmacoDto>>> {
  const rb = new RequestBuilder(rootUrl, farmacosControllerGetTodosFarmacosEliminadosPaciente.PATH, 'get');
  if (params) {
    rb.path('programaUuid', params.programaUuid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<FarmacoDto>>;
    })
  );
}

farmacosControllerGetTodosFarmacosEliminadosPaciente.PATH = '/api/farmacos/farmacos-eliminados-paciente/{programaUuid}';
